import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

//IMPORTING SHARED COMPONENTS
import { NavComponent } from "./nav/nav.component";
import { AppRoutingModule } from "../../app-routing.module";
import { SelectComponent } from "./select/select.component";
import { SurveyjsFormComponent } from "./surveyjs-form/surveyjs-form.component";

//IMPORTING REQUIRED MODULES
import { MatSelectModule } from "@angular/material/select";
import { MatListModule } from "@angular/material/list";
import { MatSidenavModule } from "@angular/material/sidenav";
import { SurveyModule } from "survey-angular-ui";
import { SvgIconComponent } from "./svg-icon/svg-icon.component";
import { SpreadsheetComponent } from "./spreadsheet/spreadsheet.component";
import { BreadcrumbsComponent } from "./breadcrumbs/breadcrumbs.component";

@NgModule({
  imports: [
    CommonModule,
    MatSidenavModule,
    MatSelectModule,
    MatListModule,
    AppRoutingModule,
    SurveyModule,
  ],
  declarations: [
    NavComponent,
    SelectComponent,
    SurveyjsFormComponent,
    SvgIconComponent,
    SpreadsheetComponent,
    BreadcrumbsComponent,
  ],
  exports: [
    NavComponent,
    SelectComponent,
    SurveyjsFormComponent,
    SvgIconComponent,
    SpreadsheetComponent,
    BreadcrumbsComponent,
  ],
})
export class SharedComponents {}
